import { Field, reduxForm } from 'redux-form';
import PSTNListItem from 'components/PSTN/PSTNListItem';
import React from 'react';
import { PropTypes as PT } from 'prop-types';
import classes from './PSTN.module.scss';

const fakePlaceholderHeight = '30px';

class PSTNSearchBar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      fakePlaceholderHeight
    };
  }

  componentDidUpdate() {
    if (this.props.blurred) {
      document.getElementById('PSTNSearch').blur();
      this.props.blurInput();
    }
  }

  searchInput = (inputProps) => {
    const { input } = inputProps;
    return (
      <input
        {...input}
        autoComplete="new-password"
        id={'PSTNSearch'}
        name={'PSTNSearch'}
        onFocus={this.props.handleFocus}
        style={{ minHeight: this.state.fakePlaceholderHeight }}
        type="text"
      />
    );
  };

  handleFakePlaceholderRender = (fakePlaceholder) => {
    if (!fakePlaceholder) return this.setState({ fakePlaceholderHeight });
    return this.setState({ fakePlaceholderHeight: `${fakePlaceholder.offsetHeight}px` });
  };

  render() {
    const { selectedCountry } = this.props;
    return (
      <div className={classes.inputWrapper} style={{ minHeight: this.state.fakePlaceholderHeight }}>
        <Field
          component={this.searchInput}
          name={'PSTNSearch'}
          placeholderHeight={this.state.fakePlaceholderHeight}
          selectedCountry={selectedCountry}
          type="text"
        />
        {!this.props.isVisible ? (
          <div className={classes.fakePlaceholder} ref={this.handleFakePlaceholderRender}>
            <PSTNListItem country={this.props.selectedCountry} />
            <div className={classes.downArrowContainer}>
              <div className={classes.downArrow} />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

PSTNSearchBar.propTypes = {
  selectedCountry: PT.object,
  handleFocus: PT.func,
  handleBlur: PT.func,
  isVisible: PT.bool,
  blurred: PT.bool,
  blurInput: PT.func
};

export default reduxForm({
  form: 'PSTN',
  enableReinitialize: true,
  fields: ['PSTNSearch'],
  getFormState: (state) => state.app.form
})(PSTNSearchBar);
